<template>
<div>
    <qriously :value="link" :size="200"></qriously> 
</div>
</template>

<script>

import Vue from 'vue'
import VueQriously from 'vue-qriously'
Vue.use(VueQriously)

export default {
  props : ['sb'],
  // components : {VueQriously},
  data: () => ({
    serverURL : process.env.VUE_APP_SERVER_URL,
    imagesURL : process.env.VUE_APP_IMAGES_URL,
  }),
  methods : {

  },
  created () {
    console.log(this.sb)
  },
  computed : {
    link : function () {
      console.log('sync',window.location)
      return window.location.origin +
              '?shopbox_sync=' +
              this.sb.uuid +
              '&r=' +
              window.location.href
    }
  }
};
</script>
<style scoped>

</style>

